import {
  ChangeDetectionStrategy,
  Component,
  input,
  linkedSignal,
  output
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { CheckboxGroup, shortDaysOfTheWeek } from '@shared/models';
import { NzButtonModule } from 'ng-zorro-antd/button';

@Component({
  selector: 'moxi-week-day-buttons',
  imports: [
    TranslatePipe,

    // Ant Design
    NzButtonModule
  ],
  templateUrl: './week-day-buttons.component.html',
  styleUrl: './week-day-buttons.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WeekDayButtonsComponent {
  selectedDays = input<number[]>();
  small = input<boolean>();
  disabled = input<boolean>();

  updateDays = output<number[]>();

  daysOfTheWeekOptions = linkedSignal<CheckboxGroup[]>(() => {
    const days = this.selectedDays();

    return shortDaysOfTheWeek.map(day => ({
      label: day.name,
      value: day.id.toString(),
      checked: days?.includes(Number(day.id))
    }));
  });

  onDayOfTheWeekClick(day: string): void {
    this.daysOfTheWeekOptions.set(
      this.daysOfTheWeekOptions().map(option => {
        if (option.value === day) {
          return {
            ...option,
            checked: !option.checked
          };
        }

        return option;
      })
    );

    const days = this.daysOfTheWeekOptions()
      .filter(option => option.checked)
      .map(option => Number(option.value));

    this.updateDays.emit(days);
  }
}
